class Config {

    constructor(){
        this.data = {};
    }

    set(key, value){
        this.data[key] = value;
    }

    get(key){
        return this.data[key];
    }
}

const config = new Config();

export default config;